import { render, staticRenderFns } from "./CompetitionType.page.vue?vue&type=template&id=7861ca6d&scoped=true"
import script from "./CompetitionType.page.vue?vue&type=script&lang=ts"
export * from "./CompetitionType.page.vue?vue&type=script&lang=ts"
import style0 from "./CompetitionType.page.vue?vue&type=style&index=0&id=7861ca6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_cache-loader@4.1.0_webpack@4.47.0__css-load_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7861ca6d",
  null
  
)

export default component.exports